<app-main-menu title="Instrumente"></app-main-menu>

<div class="content mat-elevation-z8">
  <h1>Alle Instrumente</h1>

  <mat-form-field style="width:100%">
    <mat-label>Suchen</mat-label>
    <input matInput placeholder="Suche" [(ngModel)]="searchTerm" (input)="searchInstrument($event)">
  </mat-form-field>

  <mat-list>
    <mat-list-item *ngFor="let instrument of paginatedInstruments" class="musician-list-item">
      <img matListItemIcon [src]="getInstrumentImg(instrument)" class="instr-img">
      <span matListItemTitle>
        @if(instrument.abbreviation) {
          {{ instrument.designation }}, {{ instrument.abbreviation }}
        }
        @else {
          {{ instrument.designation }}
        }

        <p class="mat-list-item-content-right">
          <button mat-raised-button color="accent" routerLink="/instruments/{{ instrument.id }}">
            Edit
          </button>
        </p>
      </span>
    </mat-list-item>
  </mat-list>

  <mat-paginator
    (page)="handlePageEvent($event)"
    [length]="instruments.length"
    [pageSize]="10"
    [pageSizeOptions]="[5, 10, 25, 100]">
  </mat-paginator>


  <button mat-button routerLink="/instruments/-1">
    <mat-icon>add_box</mat-icon>
    Instrument hinzufügen
  </button>
</div>
